import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";
import { useMemo } from "react";

export const useGetChatMembers = () => {
  const axios = useMemo(() => createAxiosWithAuth(), []);

  return useMutation({
    mutationKey: ["chat_members"],
    mutationFn: async (query) => {
      return await axios.post("/chat/members", query);
    },
  });
};
